import { Bar } from "../../components/Bar";
import { Button } from "../../components/Button";
import { CloseBtn } from "../../components/CloseBtn";
import { Col, Container, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { ProfileDetails, ProfileDetailsEdit } from "../../components/ProfileDetails";
import { Sidemenu } from "../../components/Sidemenu";
import { theme } from "../../styles/theme";
import { useState } from "react";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import CloseIcon from "../../assets/img/icons/close.svg";

export default function ProfileDataPage() {
	const [isEditMode, setIsEditMode] = useState(false);
	return (
		<>
			{isEditMode ? (
				<>
					<Bar bg={theme.color.blue0} fullWidth infobar={true}>
						<Col>
							<p>Edit mode</p>
						</Col>
						<Col>
							<div className="d-flex justify-content-end">
								<CloseBtn onClick={() => setIsEditMode(false)} icon={CloseIcon} />
							</div>
						</Col>
					</Bar>
				</>
			) : (
				<Bar fullWidth>
					<Link to="/">
						<Button bg={false} small icon={ArrowIcon}>
							Back
						</Button>
					</Link>
					<Breadcrumbs />
				</Bar>
			)}

			<Container>
				<Row>
					<Col sm={12} lg={2}>
						<Sidemenu
							items={[
								{ name: "Personal Data", path: "/profile/details" },
								{ name: "My Documents", path: "/profile/documents" },
								{ name: "My Units", path: "/profile/units" },
								{ name: "Account Settings", path: "/profile/settings" },
							]}
						/>
					</Col>
					<Col sm={12} lg={10}>
						{isEditMode && <ProfileDetailsEdit setIsEditMode={setIsEditMode} />}
						{!isEditMode && <ProfileDetails setIsEditMode={setIsEditMode} />}
					</Col>
				</Row>
			</Container>
		</>
	);
}
